import { useStore } from "zustand";
import { derive } from "@/lib/derive-zustand";
import useHeraldChatHistoryStore from "./herald-chat-history.slice";

/**
 * Derived persisted title for a conversation row.
 * Empty when `conversationId` is missing (new chat) or the row has no title yet.
 */
const createConversationTitleSelector = (conversationId: string | undefined) =>
  derive<string>((get) => {
    if (!conversationId) {
      return "";
    }

    return (
      get(useHeraldChatHistoryStore)
        .allPreviousConversations.find(
          (conversation) => conversation.id === conversationId,
        )
        ?.title?.trim() ?? ""
    );
  });

/** Persisted sidebar title for `conversationId`; empty for new / untitled chats. */
export const useHeraldConversationTitle = (
  conversationId: string | undefined,
): string => {
  const selector = createConversationTitleSelector(conversationId);
  return useStore(selector);
};
